/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import OrganizationTab from 'containers/Organizations/SingleOrganization/OrganizationTab';

const OrganizationDashboard = props => {
  return <OrganizationTab {...props} />;
};

export default OrganizationDashboard;
